export const DRIVER_REQUEST = "DRIVER_REQUEST";
export const DRIVER_SUCCESS = "DRIVER_SUCCESS";
export const DRIVER_ERROR = "DRIVER_ERROR";
export const DRIVER_params = {
    key: process.env.VUE_APP_API_KEY,
    connector: 'AppUserDriverV1',
    size: 1000,
    filter: []
};